import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/consulting2106.css';

class EventConsulting2106 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0,
      page: "left"
    };
  }

  componentDidMount() {
    window.pageVisit("consulting", "2106");
  }

  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap" className="div-cont consulting2106" style={{background: '#344a58'}}>
              <div id="contents" style={{background: '#344a58'}}>
                <div className="BgTop"></div>
                <div className="TabWrap">
                  <button className={"BtnLeft" + (this.state.page === "left" ? " on" : "")} onClick={() => this.setState({ page: "left" })}></button>
                  <button className={"BtnRight" + (this.state.page === "right" ? " on" : "")} onClick={() => this.setState({ page: "right" })}></button>
                </div>
                <div className="BgWrap" style={{ height: this.state.page === "left" ? "1302vw" : "393vw" }}>
                  <div className={"BgLeft" + (this.state.page === "left" ? " on" : "")}>
                    <a href="http://www.kcoach.education/" target="_blank" className="BtnKcoach"></a>
                    <Link to="/event/surprise_3" className="BtnSurprise"></Link>
                  </div>
                  <div className={"BgRight" + (this.state.page === "right" ? " on" : "")}>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default EventConsulting2106;
